import { setupBlocksuite, setupBrowser } from '@affine/core/bootstrap';

await setupBrowser();
setupBlocksuite();
